/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import { useId, type SVGProps } from 'react'

// Brand-asset gradient. Matches the Figma `oro-ai` glyph
// (file `LzIaMibaqIq6S9RJz2qAw1`, node `1929:7239`). Hardcoded because
// these aren't part of the surface design-token set — they're brand
// identity colours for the AI mark, in the same spirit as `OroLogo`'s
// orange→yellow gradient.
const BRAND_AI_GRADIENT_STOPS = {
  start: '#4DEF8E',
  end: '#FFEB3A',
} as const

const OroAi = (props: SVGProps<SVGSVGElement>) => {
  const reactId = useId()
  const gradientId = `oro-ai-gradient-${reactId.replace(/:/g, '')}`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 26.6667 26.6666"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7844 1.03044C16.7844 5.49013 20.3575 9.62453 25.1648 9.86928L25.6334 9.88235C26.4052 9.88235 26.6667 10.4876 26.6667 10.914V15.7558C26.6667 16.6012 26.061 16.7842 25.6364 16.7842C20.7696 16.7846 16.7974 21.1504 16.7974 25.1678L16.7844 25.6364C16.7844 26.4052 16.1808 26.6666 15.7558 26.6666H10.9109C10.0654 26.6666 9.88242 26.061 9.88242 25.6364C9.88242 21.1764 6.0547 16.7842 1.03044 16.7842C0.261438 16.7842 6.38276e-05 16.1805 6.38276e-05 15.7558L0 10.911C0 10.0653 0.605766 9.88229 1.03044 9.88229C5.80561 9.88229 9.88242 5.49013 9.88242 1.10403C9.88242 0.459214 10.4079 0 10.9815 0L15.7528 6.38276e-05C16.2942 6.38276e-05 16.7844 0.441405 16.7844 1.03044ZM9.09224 14.549C7.93807 15.2554 7.33994 15.561 6.01307 15.9476C9.51243 17.51 11.6217 20.5989 11.9085 24.6012H14.7059C14.6353 23.3072 14.3747 22.3276 13.9739 21.1504C13.7413 20.4712 13.454 19.8441 13.1242 19.2156C12.9177 18.8216 12.684 18.4361 12.4314 18.0522C11.4798 16.6255 10.4901 15.5418 9.09224 14.549ZM24.6013 11.9607C24.4085 11.9712 23.9815 12.0078 23.7908 12.0261C23.9512 12.005 23.6288 12.0417 23.7908 12.0261C22.4837 12.198 20.184 12.9301 18.5621 13.9869C17.083 14.9506 15.5839 16.1346 14.5621 17.5716C15.2692 18.7264 15.5608 19.2603 15.9477 20.5882C17.5101 17.0893 20.5995 15.0451 24.6013 14.7581V11.9607ZM13.3304 10.8758C12.4969 11.9633 11.9115 12.4995 10.8235 13.3334C11.9121 14.1673 12.4988 14.7282 13.3334 15.8169C14.1671 14.7297 14.7287 14.1675 15.817 13.3334C14.7287 12.4998 14.1648 11.9641 13.3304 10.8758ZM10.719 6.01301C9.15545 9.50923 6.06544 11.6218 2.06536 11.9084V14.7058C4.16682 14.5911 6.35047 13.6263 8.10457 12.6797C7.91348 12.795 8.30139 12.5734 8.10457 12.6797C9.75547 11.6835 10.9114 10.6637 12.0261 9.09524C11.3196 7.9414 11.1059 7.33953 10.719 6.01301ZM11.9608 2.0653C12.0982 4.58482 12.9444 6.37196 14.2484 8.36595C15.2095 9.83253 16.1398 11.0766 17.5686 12.0914C17.5156 12.1212 17.6682 12.0159 17.5686 12.0914C18.5856 11.5189 19.4462 11.0388 20.5882 10.7058C17.5686 9.09524 15.2941 6.14373 14.7582 2.0653H11.9608Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="26.6664"
          x2="26.6663"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={BRAND_AI_GRADIENT_STOPS.start} />
          <stop offset="1" stopColor={BRAND_AI_GRADIENT_STOPS.end} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default OroAi
